import { render, staticRenderFns } from "./IndicadorFormulaPerfil.vue?vue&type=template&id=f679632a"
import script from "./IndicadorFormulaPerfil.vue?vue&type=script&lang=js"
export * from "./IndicadorFormulaPerfil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports